import React, { useContext } from 'react';
import Chip from '@mui/material/Chip';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import { MsalContext } from '../../Contexts/MsalContext';

interface ITagChipProps {
    label: string,
    tagID: string,
    systemPK: string,
    onUpdate: () => void,
}

export default function TagChip({ label, tagID, systemPK, onUpdate }: ITagChipProps) {
    const { msalFetch } = useContext(MsalContext);

    const handleDelete = () => {
        msalFetch('api/Info/RemoveTagFromCall?systemPK=' + encodeURI(systemPK) + '&tagId=' + encodeURI(tagID))
            .then(() => onUpdate());
    }

    return (
        <Chip
            sx={{ pr: 1 }}
            label={label}
            onDelete={handleDelete}
            icon={<LocalOfferIcon />}
        />
    );
}